import { API } from "../utils";

const isFormData = (body) =>
  typeof FormData !== "undefined" && body instanceof FormData;

const multipartConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
  timeout: 120000,
};

export const getTicketCategories = async () => {
  const response = API.get("/organization/tickets/categories");
  const data = await response;
  return data;
};

export const getTickets = async ({ params }) => {
  const response = API.get("/organization/tickets", { params });
  const data = await response;
  return data;
};

export const getSingleTicket = async ({ params }) => {
  const response = API.get(`/organization/tickets/${params.id}`);
  const data = await response;
  return data;
};

export const createTicket = async ({ body }) => {
  const response = API.post(
    "/organization/tickets",
    body,
    isFormData(body) ? multipartConfig : undefined
  );
  const data = await response;
  return data;
};

export const replyTicket = async ({ params, body }) => {
  const response = API.post(
    `/organization/tickets/${params.id}/replies`,
    body,
    isFormData(body) ? multipartConfig : undefined
  );
  const data = await response;
  return data;
};

export const closeTicket = async ({ params }) => {
  const response = API.put(`/organization/tickets/${params.id}/close`);
  const data = await response;
  return data;
};
